/* eslint-disable max-len */

import { getApiUrl, JOB_API_URL } from '../../util/api/api'
import type { JobPostingProduct } from '../../../state/reducers/entitlement/entitlement'
import { parse } from 'cookie'

const getPayload = (product, upgrades) => {
  const payload = {} as any
  if (product) { payload.jobPosting = product }
  if (upgrades?.length) { payload.jobUpgrades = upgrades }
  return payload
}

const getFeatureFlagsHeader = (): string | undefined => {
  if (typeof document === 'undefined' || !document.cookie) {
    return undefined
  }

  const cookies = parse(document.cookie)
  return cookies['feature-flags']
}

const submitDraft = async (id: string, product?: JobPostingProduct, upgrades?: Array<any>): Promise<any> => {
  const featureFlags = getFeatureFlagsHeader()
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }

  if (featureFlags) {
    headers['x-feature-flags'] = featureFlags
  }

  const fetchResponse = await fetch(
    getApiUrl(`${JOB_API_URL}/${id}/submit`), {
      method: 'PUT',
      headers,
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify(getPayload(product, upgrades)),
    }
  )

  if (fetchResponse?.ok) {
    const responseData = await fetchResponse.text()
    return Promise.resolve({ status: fetchResponse.status, data: responseData})
  } else {
    return Promise.reject(fetchResponse ? { status: fetchResponse.status, data: fetchResponse.statusText } : null)
  }
}
  
export default submitDraft
